import ApisService from './index'
import { IPriceCategorieAdd, IPriceCategorieImport, IPriceCategorieUpdate } from '../interfaces/priceCategorieInterfaces'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'

export function createPriceCategorie(data: IPriceCategorieAdd) {
  try {
    return ApisService.post('/nhomgia/create-nhom-gia', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function updatePriceCategorie(data: IPriceCategorieUpdate) {
  try {
    return ApisService.put('/nhomgia/' + data.id + '/update-nhom-gia', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getDetailPriceCategorie(id: string) {
  try {
    return ApisService.get('/nhomgia/' + id + '/get-chi-tiet-nhom-gia')
  } catch (err) {
    handleError(err)
    throw err
  }
}


export function getListPriceCategorie(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/nhomgia/filter-nhom-gia', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deletePriceCategorie(id: string) {
  try {
    return ApisService.delete('/nhomgia/' + id + '/delete-nhom-gia')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteMultiPriceCategorie(idArr: Array<string>) {
  try {
    return ApisService.delete('/nhomgia/bulk-delete-nhom-gia', { data: idArr })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function importPriceCategorie(data: Array<IPriceCategorieImport>) {
  try {
    return ApisService.post('/nhomgia/import-nhom-gia', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}